import { ISortable } from '../../../../app/helpers/sort';

export enum sortTypes {
    ID = 0,
    Username = 1,
    FirstName = 2,
    LastName = 3,
    Email = 4,
    MobilePhone = 5,
    UserStatus = 6,
    UserRole = 10,
}

export enum sortDirection {
    Ascending = 0,
    Descending = 1,
    Unsorted = 2,
    SingleItem = 3,
    NotSpecified = 4
}

export interface IMemberDashboardMembershipUserResponse {

    ID: number;
    Username: string;
    FirstName: string;
    LastName: string;
    Email: string;
    MobilePhone: string;
    UserStatus: string;
    UserRole: string;
    DateTimeCreated: Date;
    DateTimeUpdated: Date;
}

export interface ISortItem {
    SortType: sortTypes;
    SortDirection: sortDirection;
    SortCol: string;
}

export class SortItem implements ISortItem {
    SortType: sortTypes;
    SortDirection: sortDirection;
    SortCol: string;

    constructor() {
        this.SortType = sortTypes.ID;
        this.SortDirection = sortDirection.NotSpecified;
    }

}

 
export class MemberDashboardMembershipUserResponse implements IMemberDashboardMembershipUserResponse {

    ID: number;
    Username: string;
    FirstName: string;
    LastName: string;
    Email: string;
    MobilePhone: string;
    UserStatus: string;
    UserRole: string;
    DateTimeCreated: Date;
    DateTimeUpdated: Date;

    public static FixDate(membershipUser: MemberDashboardMembershipUserResponse) {
        membershipUser.DateTimeCreated = new Date(membershipUser.DateTimeCreated);
        membershipUser.DateTimeUpdated = new Date(membershipUser.DateTimeUpdated);
    }

}

export class MemberDashboardMembershipUserResponseArray extends Array<MemberDashboardMembershipUserResponse> {

    constructor(...items: MemberDashboardMembershipUserResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, MemberDashboardMembershipUserResponseArray.prototype);
    }

    public static FixDates(membershipUsers: MemberDashboardMembershipUserResponseArray) {

        membershipUsers.forEach(x => {
            x.DateTimeCreated = new Date(x.DateTimeCreated);
            x.DateTimeUpdated = new Date(x.DateTimeUpdated);
        });

    }


}
